import { hybridEnabled, hybridApi, hybridFile } from './hybridApi';
export { hybridEnabled } from './hybridApi';
const origin = process.env.REACT_APP_BACKEND_URL;
if (!origin && !hybridEnabled) throw new Error('REACT_APP_BACKEND_URL non configurato');
let csrf = '';
export const setCsrf = (value) => { csrf = value || ''; };
export const getCsrf = () => csrf;
export const apiUrl = (path) => hybridEnabled ? path : `${origin}/api/v1${path}`;

export async function api(path, options = {}) {
  if (hybridEnabled) return hybridApi(path, options);
  const method = options.method || 'GET';
  const raw = options.raw;
  const headers = { ...(options.headers || {}) };
  if (method !== 'GET' && method !== 'HEAD' && csrf) headers['X-CSRF-Token'] = csrf;
  if (options.body && !raw) headers['Content-Type'] = 'application/json';
  const response = await fetch(apiUrl(path), {
    method, credentials: 'include', headers,
    body: raw || (options.body ? JSON.stringify(options.body) : undefined),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401) window.dispatchEvent(new Event('agrinext:session-expired'));
    const detail = Array.isArray(data.detail) ? data.detail.map((item) => item.msg).join(', ') : data.detail;
    throw new Error(detail || `Richiesta non riuscita (${response.status})`);
  }
  return data;
}

export async function download(path, filename) {
  let blob;
  if (hybridEnabled) blob = await hybridFile(path);
  else {
    const response = await fetch(apiUrl(path), { credentials: 'include' });
    if (!response.ok) throw new Error('Download non disponibile o accesso scaduto.');
    blob = await response.blob();
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const upload = (path, file, fields = {}) => api(path, {
  method: 'POST', raw: file, headers: Object.fromEntries(
    Object.entries({ 'X-Filename': file.name, ...fields }).map(([key, value]) => [key, encodeURIComponent(value || '')])
  ),
});

export async function preview(event,path,onError) {
  if(!hybridEnabled) return;
  event.preventDefault();
  const tab=window.open('about:blank','_blank');
  try {
    const url=URL.createObjectURL(await hybridFile(path));
    if(tab) {tab.opener=null;tab.location.replace(url);} else throw new Error('Consenti l’apertura dell’anteprima nel browser.');
    setTimeout(()=>URL.revokeObjectURL(url),60000);
  } catch(error) {tab?.close();onError?.(error.message);}
}
